<template>
    <div class="flex h-full flex-col justify-center text-center">
        <div class="mb-4 text-8xl font-bold text-gray-900">
            {{ displayedTitle }}
        </div>
        <p
            class="line-height-3 mx-auto mb-5 mt-0 max-w-md text-xl font-medium text-gray-700"
        >
            {{ displayedText }}
        </p>
        <nuxt-link
            :to="facilityHome"
            class="mt-4 text-gray-700"
        >
            <prime-button> Back to Home </prime-button>
        </nuxt-link>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import { useActiveFacility } from '~/composables/use-active-facility'
import { computed } from 'vue'
import { useRouteLink } from '~/composables/routing'

const props = defineProps<{
    title?: string
    reason?: string
}>()

const activeFacility = useActiveFacility()
const { facilityHomeLink } = useRouteLink()
const facilityHome = computed(() => facilityHomeLink(activeFacility.value.slug))

const displayedTitle = computed(() => {
    return props.title ?? 'Oops!'
})

const displayedText = computed(() => {
    return props.reason ?? 'There is nothing here'
})
</script>
